export const SIGNAL_R_PROPERTIES = {
  notificationsHub: 'ops-notifications-hub',
  method: 'messages',
};
